import { render, staticRenderFns } from "./ServiceToServiceCommunications.vue?vue&type=template&id=4f45635a&scoped=true"
import script from "./ServiceToServiceCommunications.vue?vue&type=script&lang=js"
export * from "./ServiceToServiceCommunications.vue?vue&type=script&lang=js"
import style0 from "./ServiceToServiceCommunications.vue?vue&type=style&index=0&id=4f45635a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f45635a",
  null
  
)

export default component.exports